import { fetchHistoricLogs } from '@/features/AudienceManager/data';
const audienceManagerHistoric = {
    namespaced: true,
    state: {
        isLoadingCompositionStage: false,
        historicLogs: [],
        selectedConnectorIdFilterHistoric: '',
        paginationTable: {
            limit: 10,
            page: 1,
            count: 0,
        },
        isLoadingHistoricStage: false,
    },
    getters: {
        isLoadingHistoricStage: state => state.isLoadingHistoricStage,
        historicLogs: state => state.historicLogs,
        getSelectedConnectorIdFilterHistoric: state => state.selectedConnectorIdFilterHistoric,
        getPagination: state => state.paginationTable,
    },
    actions: {
        fetchHistoric({ commit, state }, pagination) {
            commit('SET_LOADING_HISTORIC_STAGE', true);
            const payload = {
                audienceId: state.audienceId,
                connectorId: state.selectedConnectorIdFilterHistoric,
                limit: pagination?.limit || 10,
                page: pagination?.page || 1,
                orderBy: '',
            };
            fetchHistoricLogs(payload)
                .then(response => {
                commit('SET_HISTORIC_LOGS', response.data);
                commit('SET_TOTAL_COUNT', response.totalCount);
            })
                .finally(() => {
                commit('SET_LOADING_HISTORIC_STAGE', false);
            });
        },
    },
    mutations: {
        SET_LOADING_HISTORIC_STAGE(state, isLoading) {
            state.isLoadingHistoricStage = isLoading;
        },
        SET_HISTORIC_LOGS(state, historicLogs) {
            state.historicLogs = historicLogs;
        },
        SET_SELECTED_CONNECTOR_ID_FILTER_HISTORIC(state, connectorId) {
            state.selectedConnectorIdFilterHistoric = connectorId;
        },
        SET_TOTAL_COUNT(state, totalCount) {
            state.paginationTable.count = totalCount;
        },
    },
};
export default audienceManagerHistoric;
